import { createSignal } from "solid-js"
import type { TileGraphEdge } from "../../lib/core/engine/TileGraphEdge/TileGraphEdge.type"
import { immutableEmptyArray } from "../../lib/lib"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useTileEdgeListSignal = createSharedCachedFactory((
  // engine: Engine
) => {

  // eslint-disable-next-line solid/reactivity
  const signal = createSignal<Array<TileGraphEdge>>(immutableEmptyArray as unknown as Array<TileGraphEdge>)

  return signal
})


